import React, { useEffect } from 'react';
import { browserHistory, withRouter } from 'react-router';
import styles from './Header.css';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import HeaderComp from 'fk-cp-shared/components/android/Header';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';
import WithWebHeader from './WithWebHeader';
import Flags from '@utils/Flags';
window['onBackPress'] = function () {
    browserHistory.goBack();
};
export var updateNativeHeader = function (headerText) {
    var _a, _b;
    var headerUpdated = false;
    if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.setActionBarTitle) === 'function') {
        window.Android.setActionBarTitle(headerText);
        headerUpdated = true;
    }
    else if (UAHelper._isIOS()) {
        // check for iOS and set the title here.
        if (IOSNativeCaller.bridgeAvailable()) {
            setTimeout(function () {
                IOSNativeCaller.run('setActionBarTitle', { text: headerText });
            }, 200);
            headerUpdated = true;
        }
    }
    return headerUpdated;
};
var handleBack = function (onBack) {
    var _a, _b;
    if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.setHandleBackPress) === 'function') {
        if (typeof onBack === 'function') {
            /* Register `onBackPress` before enabling back press handling to avoid a race condition.
             * The native side checks if `setHandleBackPress` is true before calling `onBackPress`.
             */
            window['onBackPress'] = function () {
                onBack();
            };
            setTimeout(function () {
                window.Android.setHandleBackPress(true);
            }, 0);
        }
        else {
            window.Android.setHandleBackPress(false);
        }
    }
    else if (UAHelper._isIOS() && IOSNativeCaller.bridgeAvailable()) {
        if (typeof onBack === 'function') {
            window['onBackPress'] = onBack;
        }
    }
};
var handleShowClose = function (show, onBack, iosBackPressEnabled) {
    var _a, _b;
    if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.setWebViewBackButtonToCross) === 'function') {
        window.Android.setWebViewBackButtonToCross(show);
    }
    else if (UAHelper._isIOS() && IOSNativeCaller.bridgeAvailable()) {
        var isHandleBack_1 = typeof onBack === 'function' && iosBackPressEnabled;
        setTimeout(function () {
            IOSNativeCaller.run('setCrossButtonAndHandleBack', {
                showCrossButton: show,
                isHandleBackEnabled: isHandleBack_1
            });
        }, 400);
    }
};
var Header = function (props) {
    var _a = props.showHome, showHome = _a === void 0 ? true : _a, _b = props.showAccount, showAccount = _b === void 0 ? true : _b, _c = props.children, children = _c === void 0 ? '' : _c, _d = props.onBack, onBack = _d === void 0 ? null : _d, _e = props.showClose, showClose = _e === void 0 ? false : _e, _f = props.iosBackPressEnabled, iosBackPressEnabled = _f === void 0 ? false : _f;
    var isHeaderUpdated = updateNativeHeader(children);
    var showWhiteHeaderFlag = Flags.showWhiteHeader;
    useEffect(function () {
        if (!UAHelper._isAndroid() || typeof document === 'undefined')
            return;
        var handleVisibilityChange = function () {
            var _a, _b;
            var isHidden = document.hidden;
            if (typeof ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.setHandleBackPress) === 'function') {
                // If document is hidden, set to false; otherwise, true
                window.Android.setHandleBackPress(!isHidden);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
        handleBack(onBack);
        handleShowClose(showClose, onBack, iosBackPressEnabled);
        updateNativeHeader(children);
    }, [isHeaderUpdated, onBack, children]);
    return isHeaderUpdated ? null : (<div>
			<div className={styles.theHeader}>
				<HeaderComp showBack={!showClose} showHome={showHome} showAccount={showAccount} title={children} onBack={showClose ? null : onBack} onClose={showClose ? onBack : null} showClose={showClose} background={showWhiteHeaderFlag ? '#FFFFFF' : '#2874F0'} isWhiteHeader={showWhiteHeaderFlag}/>
			</div>
			
			<div className={styles.dummyRelativeNew}/>
		</div>);
};
export default withRouter(WithWebHeader(Header));
